import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import { useQuery } from '@zenbusiness/application-commons-graphql';

import { BUSINESS_TYPES } from '#client/constants/businessTypes';
import { BANKING_ELIGIBILITY_STATUS } from '#client/constants/validationMessages';
import useConstBusinessEntityUuid from '#client/hooks/useConstBusinessEntityUuid';
import { useLogError } from '#client/hooks/useLogError';
import useMemoObject from '#client/hooks/useMemoObject';
import { BANKING_ELIGIBILITY_CHECK } from '#client/queries';

export default function useBankingEligibilityCheck({ isSkip = false }) {
  const { businessEntityUuid } = useConstBusinessEntityUuid();
  const {
    error,
    errors,
    data: originalData,
    loading
  } = useQuery(BANKING_ELIGIBILITY_CHECK, {
    variables: {
      input: {
        businessUuid: businessEntityUuid
      }
    },
    skip: !businessEntityUuid || isSkip,
    skipCache: true,
    noThrow: true
  });
  useLogError(errors, error);
  const data = useMemoObject(originalData);
  const bankingEligibilityStatus = data?.bankingEligibilityCheck?.bankingEligibilityStatus || '';

  const {
    businessEntity: { type }
  } = useBusinessEntity();

  const isCCorp = type === BUSINESS_TYPES.CORPORATION;
  const isMoreThanOneOwner =
    bankingEligibilityStatus === BANKING_ELIGIBILITY_STATUS.MORE_THAN_ONE_OWNER;
  const isBankingWindDown =
    bankingEligibilityStatus === BANKING_ELIGIBILITY_STATUS.BANKING_WIND_DOWN;
  const isEligibleForBanking = !isMoreThanOneOwner && !isBankingWindDown && !isCCorp;

  return {
    isEligibleForBanking,
    bankingEligibilityStatus,
    isCheckingEligibleBankingApplication: loading,
    eligibleBankingApplicationError: error
  };
}
